import { Tag as _Tag } from 'antd5';
import styled from 'styled-components';

import { Theme } from 'utils/color/horizonTheme';

export const Tag = styled(_Tag)`
  ${({ theme }) =>
    theme.themeName === Theme.Dark &&
    `
      background: ${theme.activeMenuItemBackgroundColor};
      border-color: ${theme.tertiaryBackgroundColor};
      color: ${theme.secondaryTextColor};
  `}
`;
